/**
 * 알림 카테고리 상수
 */
export const NOTIFICATION_CATEGORIES = {
  ONEDAY_REQUEST: 'oneday_request',
  LESSON_REQUEST: 'lesson_request',
  MODIFICATION_REQUEST: 'modification_request',
  MODIFICATION_APPROVED: 'modification_approved',
  MODIFICATION_REJECTED: 'modification_rejected',
  PRACTICE_BOOKED: 'practice_booked',
  PAYMENT_DUE: 'payment_due',
  LESSON_REQUEST_APPROVED: 'lesson_request_approved',
  LESSON_REQUEST_REJECTED: 'lesson_request_rejected',
  CANCEL_LESSON: 'cancel_lesson',
  ANNOUNCEMENT: 'announcement',
} as const;

/**
 * 알림 요청 타입 상수
 */
export const NOTIFICATION_REQUEST_TYPES = {
  CANCEL_LESSON: 'cancel_lesson',
  MODIFY_SCHEDULE: 'modify_schedule',
} as const;
